import * as React from 'react';
import EDLocalMenu from './EDLocalMenu';
import { PopoverOrigin } from '@mui/material/Popover';

interface IProps {
  menuLabel?: string;
  selected?: number;
  noClickPropagation?: boolean;
  clickableElement: (
    onClick: (event: React.MouseEvent<HTMLElement>) => void
  ) => React.ReactElement<any>;
  setMenuOpen?: (open: boolean) => void;
  anchorOrigin?: PopoverOrigin;
  transformOrigin?: PopoverOrigin;
  children: React.ReactNode;
}

const EDLabelMenu: React.FC<IProps> = ({
  clickableElement,
  setMenuOpen,
  children,
  ...otherProps
}) => {
  const [functionMenuAnchor, setFunctionMenuAnchor] = React.useState<
    HTMLElement | undefined
  >(undefined);

  const handleFunctionMenuClick = React.useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      setFunctionMenuAnchor(event.currentTarget);
      setMenuOpen?.(true);
    },
    [setMenuOpen]
  );

  const handleFunctionMenuClose = React.useCallback(
    (nextOnClick?: () => void) => () => {
      setFunctionMenuAnchor(undefined);
      setMenuOpen?.(false);
      nextOnClick?.();
    },
    [setMenuOpen]
  );

  return (
    <>
      {clickableElement(handleFunctionMenuClick)}
      <EDLocalMenu
        {...otherProps}
        close={handleFunctionMenuClose}
        functionMenuAnchor={functionMenuAnchor}
      >
        {children}
      </EDLocalMenu>
    </>
  );
};

export default EDLabelMenu;
